import { render, staticRenderFns } from "./TableKraByUser.vue?vue&type=template&id=edc9809e&scoped=true"
import script from "./TableKraByUser.vue?vue&type=script&lang=js"
export * from "./TableKraByUser.vue?vue&type=script&lang=js"
import style0 from "./TableKraByUser.vue?vue&type=style&index=0&id=edc9809e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc9809e",
  null
  
)

export default component.exports